import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import SuspenseWithLoader from 'components/consumer/SuspenseWithLoader';
import PDPDesktopHeroGallery from '../PDPDesktopHeroGallery';
import PDPKeySellingPoints from '../PDPKeySellingPoints';
import PDPDesktopMarxentConfigurator from '../../modular-configurator/PDPMarxentConfigurator';
const PDPDesktopPhotoPanelInner = t0 => {
  const $ = _c(11);
  const {
    isEditOrder: t1,
    pdpIsModularBYOProduct: t2,
    slug,
    hideMarxent: t3,
    unavailableFabric: t4
  } = t0;
  const isEditOrder = t1 === undefined ? false : t1;
  const pdpIsModularBYOProduct = t2 === undefined ? false : t2;
  const hideMarxent = t3 === undefined ? true : t3;
  const unavailableFabric = t4 === undefined ? false : t4;
  let t5;
  if ($[0] !== hideMarxent || $[1] !== isEditOrder || $[2] !== pdpIsModularBYOProduct || $[3] !== slug || $[4] !== unavailableFabric) {
    t5 = pdpIsModularBYOProduct ? <PDPDesktopMarxentConfigurator pdpIsModularBYOProduct={pdpIsModularBYOProduct} slug={slug} key={slug} hideMarxent={hideMarxent} unavailableFabric={unavailableFabric} /> : <PDPDesktopHeroGallery isEditOrder={isEditOrder} pdpIsModularBYOProduct={pdpIsModularBYOProduct} />;
    $[0] = hideMarxent;
    $[1] = isEditOrder;
    $[2] = pdpIsModularBYOProduct;
    $[3] = slug;
    $[4] = unavailableFabric;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== isEditOrder) {
    t6 = !isEditOrder && <PDPKeySellingPoints />;
    $[6] = isEditOrder;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== t5 || $[9] !== t6) {
    t7 = <div className="sticky top-8">{t5}{t6}</div>;
    $[8] = t5;
    $[9] = t6;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  return t7;
};
PDPDesktopPhotoPanelInner.propTypes = {
  isEditOrder: PropTypes.bool,
  pdpIsModularBYOProduct: PropTypes.bool,
  slug: PropTypes.string,
  hideMarxent: PropTypes.bool,
  unavailableFabric: PropTypes.bool
};
const PDPDesktopPhotoPanel = props => {
  const $ = _c(2);
  let t0;
  if ($[0] !== props) {
    t0 = <SuspenseWithLoader><PDPDesktopPhotoPanelInner {...props} /></SuspenseWithLoader>;
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
};
export default PDPDesktopPhotoPanel;